import React from "react";

import { getTimeDifference } from "shared/lib/functions";

import FormattedMessage from "@components/UI/FormattedMessage";

type Props = {
  arrivalDateTime: string;
  departureDateTimeNextSegment: string;
};

export default function FlightDetailStreamTransfer({
  arrivalDateTime,
  departureDateTimeNextSegment,
}: Props) {
  const { hours, minutes } = getTimeDifference(
    arrivalDateTime,
    departureDateTimeNextSegment
  );

  return (
    <div className="flight-detail-one-way-transfer">
      <FormattedMessage id="Flight.transferTime" />: <b>{hours}</b>{" "}
      <FormattedMessage id="Units.hours" /> <b>{minutes}</b>{" "}
      <FormattedMessage id="Units.minutes" />
    </div>
  );
}
